/*
 *###############################################################################
 *Module Name                   : PromotionMaster.js                            #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Dinisuru Balasuriya                           #
 *Date                          : Thursday , February 9th 2023, 16:57:00 pm     #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                           #
 *###############################################################################
 */

import React, { useState, useEffect } from "react"
import { Col, Row, Button, Label } from "reactstrap"
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import CouponUpload from "../../../assets/File/CouponUpload.xlsx";
import * as XLSX from "xlsx";
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid";
import ReactPaginate from "react-paginate";
import DPAlert from "framework/widgets/DPAlert";

const PromotionCouponContent = ({
    couponList,
    setCouponList,
    disabledCode,
    couponFromDate,
    couponToDate,
    couponBillvalueFrom,
    couponBillvalueTo,
    couponFromDateOnchange,
    couponToDateOnchange,
    couponBillvalueFromOnchange,
    couponBillvalueToOnchange,
    couponBillvalueFromOnBlur,
    couponBillvalueToOnblur,
    disabled,
    triggerClear,
    addNew,
}) => {


    const [valueUpload, setvalueUpload] = useState("")
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [showCancel, setshowCancel] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(10)
    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = couponList.slice(indexOfFirstPost, indexOfLastPost) //current posts list 

    useEffect(() => {
        setCurrentPage(1)
    }, [triggerClear])


    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    const readExcel = (file) => {
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        var couponList = []
        fileReader.onload = (e) => {
            const bufferArray = e.target.result;
            const wb = XLSX.read(bufferArray, { type: "buffer" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws);

            data.forEach(item => {
                if (item.Coupon && !couponList.find(c => c.Coupon === item.Coupon)) {
                    couponList.push({ coupon: item.Coupon, description: item.Description });
                }
            });

            setCouponList(couponList)
            setAlertDescription("Warning! Coupons can not be deleted or edited after saving!")
            setsweetAlertShow(true)
        };

        setTimeout(() => {
            setvalueUpload("")
        }, 1000);

    }

    return (
        <React.Fragment>
            <Row className="mb-1">
                <Col sm={12} md={6} className="mb-4-sm">
                    <Label
                    >
                        Promotion Coupon Redemtion
                    </Label>
                </Col>
                <Col sm={12} md={3} className="mb-4-sm"></Col>
                {addNew ? <Col sm={12} md={3} className="mb-4-sm">
                    <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                        <li className="import-export-button" style={{ display: "block" }}>
                            <input
                                id="couponfile"
                                type="file"
                                onChange={(e) => {
                                    const myfile = e.target.files[0];
                                    readExcel(myfile);
                                    setvalueUpload(e.target.value)
                                }}
                                value={valueUpload}
                                disabled={disabled}
                                accept=".xlsx, .xls, .csv"
                                style={{ display: "none" }}
                            />

                            <label htmlFor="couponfile" title="CouponUpload" style={{ cursor: "pointer", opacity: disabled == true ? "0.5" : "1" }}>
                                <span >
                                    <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                </span>
                            </label></li>

                        <li className="import-export-button" style={{ display: "block" }}>
                            <a href={CouponUpload} download="CouponUpload" data-tip title="CouponUpload Template"
                                style={{ pointerEvents: disabled ? 'none' : '', }} >
                                <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabled == true ? "0.5" : "1" }}></img>
                            </a></li>
                    </ul>
                </Col> : null}
            </Row>
            <Row className="mb-2">
                <Col sm={12} md={6} className="mb-4-sm">
                    <Row>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Start Date From</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={couponFromDate}
                                onChange={couponFromDateOnchange}
                                textType={"date"}
                                disabled={disabled ? true : addNew ? false : true}
                            />
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>To</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={couponToDate}
                                onChange={couponToDateOnchange}
                                textType={"date"}
                                disabled={disabled ? true : addNew ? false : true}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className="mb-2">
                <Col sm={12} md={6} className="mb-4-sm">
                    <Row>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Bill Value From
                                </Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={couponBillvalueFrom}
                                onChange={couponBillvalueFromOnchange}
                                textAlign="right"
                                onBlur={couponBillvalueFromOnBlur}
                                disabled={disabled ? true : addNew ? false : true}
                            />
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>To</Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={couponBillvalueTo}
                                onChange={couponBillvalueToOnchange}
                                textAlign="right"
                                onBlur={couponBillvalueToOnblur}
                                disabled={disabled ? true : addNew ? false : true}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>


            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <table className="table table-bordered  table-sm rounded">
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>Coupon</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentPosts.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td style={{ width: "50px" }}>{indexOfFirstPost + index + 1}</td>
                                        <td>{item.coupon}</td>
                                        <td>{item.description}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </Col>
                <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                        color="secondary"
                        className="btn btn-secondary waves-effect waves-light"
                        style={{ width: "100%" }}
                        size="sm"
                        onClick={() => {
                            setCouponList([])
                        }}
                        disabled={disabledCode ? true : addNew ? false : true}
                    >
                        Clear
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <ReactPaginate
                        previousLabel={'previous'}
                        nextLabel={'next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(couponList.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-end pagination-sm'}

                    />
                </Col>
            </Row>
            <DPAlert
                confirm_both={sweetAlertShow}
                title={"Prmotion"}
                description={AlertDescription}
                showCancel={showCancel}
                warning={true}
                btnColor={"success"}
                cancelColor={"danger"}
                btnYes={showCancel ? "Yes" : "Ok"}
                onConfirm={() => {
                    setsweetAlertShow(false)
                }}
                onCancel={() => {
                    setsweetAlertShow(false)
                }}
            />
        </React.Fragment>
    )


}

export default PromotionCouponContent